import { Checkbox } from '@/components//ui/checkbox'
import { Label } from '@/components/ui/label'
import { ComponentProps } from 'react'

type ViverseCheckboxProps = ComponentProps<typeof Checkbox>

function ViverseCheckbox({ checked, onCheckedChange, children, ...props }: ViverseCheckboxProps) {
  return (
    <div className="flex w-fit items-center gap-[16px] py-[10px]">
      <Checkbox
        id={props.id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className="data-[state=checked]:text-primary-70 bg-vive-primary-70 text-vive-primary-70 hover:bg-vive-primary-60 data-[state=checked]:bg-primary size-5 cursor-pointer border-none transition-all"
        {...props}
      />
      <Label
        htmlFor={props.id}
        className="body-1 text-vive-white cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
      >
        {children}
      </Label>
    </div>
  )
}

export default ViverseCheckbox
